import { render } from "./AssessmentTaxNewNew.vue?vue&type=template&id=2b849e92&scoped=true"
import script from "./AssessmentTaxNewNew.vue?vue&type=script&lang=js"
export * from "./AssessmentTaxNewNew.vue?vue&type=script&lang=js"

import "./AssessmentTaxNewNew.vue?vue&type=style&index=0&id=2b849e92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b849e92"]])

export default __exports__